import { createNamedContext } from '@trinity/chat-components';
import type { BrandActions, BrandMenuItems, BrandState, BrandProjectTracker } from './interfaces';

export const BrandActionsContext = createNamedContext<BrandActions.Context>(undefined, 'WorkspaceBrand.Actions.Context');
export const BrandMenuItemsContext = createNamedContext<BrandMenuItems.Context>(undefined, 'WorkspaceBrand.MenuItems.Context');

export const BrandLoadingContext = createNamedContext<boolean>(undefined, 'WorkspaceBrand.Loading.Context');
export const BrandStateContext = createNamedContext<BrandState.Context>(undefined, 'WorkspaceBrand.State.Context');

export const BrandProjectTrackerContext = createNamedContext<BrandProjectTracker.Context>(undefined, 'WorkspaceBrand.ProjectTracker.Context');